import { SettingsState } from './types';

export const initialState: SettingsState = {
  isGameSearchActive: false,
  isCookiesAccepted: localStorage.getItem('cookiesAccepted') === 'true'
};
